import { getTransferTypes } from '@/services/files.service';

const Model = {
  namespace: 'providerFilesList',

  state: {
    transferTypes: [],
  },

  effects: {
    *fetchTransferTypes(_, { call, put }) {
      try {
        const response = yield call(getTransferTypes);
        const data = Array.isArray(response.data) ? response.data : [];
        yield put({
          type: 'setData',
          payload: { transferTypes: data.filter((item) => item?.enabled !== false) },
        });
      } catch {}
    },
  },

  reducers: {
    setData(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};

export default Model;
